import {Box, Typography} from "@mui/material";
import styles from './image-formatter.module.scss';

type Props = {
    title?: string;
    alt?: string;
    borderRadius?: string;
    height?: string;
    width?: string;
    isBackground?: boolean;
    backgroundPosition?: string;
    imgStyleProps?: React.CSSProperties;
    backgroundSize?: string;
    displayCaption?: boolean;
    captionPosition?: 'top' | 'bottom';
    children?: React.ReactNode;
    src: string;
    fadeIn?: boolean;
    className?: string
};

const ImageFormatter = ({
                            title,
                            borderRadius,
                            alt,
                            height = '280px',
                            width = '100%',
                            isBackground,
                            backgroundPosition = 'center',
                            backgroundSize = 'cover',
                            imgStyleProps,
                            displayCaption = false,
                            captionPosition = 'bottom',
                            caption,
                            src,
                            children,
                            fadeIn,
                            className

                        }: Props) => {

    const imgStyle = {
        height,
        width,
        backgroundPosition,
        backgroundSize,
        borderRadius: borderRadius ? borderRadius : '0',
        backgroundImage: `url(${src})`,
        backgroundRepeat: 'no-repeat',
        position: children ? 'relative' : 'inherit',
        ...imgStyleProps
    };

    return (
        <Box sx={{position: 'relative'}}>
            <>
                {isBackground ? (
                    <div className={`${styles.imgBackground} ${fadeIn ? 'fade-in' : ''} ${className}`} style={imgStyle} >
                        {children}
                    </div>
                ) : (
                    <img src={src} className={`img ${className}`} title={title} alt={alt} height={height} width={width}/>
                )}
                {(displayCaption && caption?.length) && (
                    <Box
                        sx={{
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: captionPosition === 'top' ? 0 : 'inherit',
                            bottom: captionPosition === 'bottom' ? 0 : 'inherit',
                            p: 2,
                            background: 'rgba(255,255,255,0.7)',
                            color: 'black',
                        }}
                    >
                        <Typography variant="caption">{caption}</Typography>
                    </Box>
                )}
            </>
        </Box>
    );
};

export default ImageFormatter;
